import Box from "@amzn/awsui-components-react-v3/polaris/box";
import React from "react";

interface MeasurementProps {
    value?: number,
    unitOfMeasure?: string
}

export const Measurement = (props: MeasurementProps) => {
    const hasValue = props.value !== undefined && props.unitOfMeasure !== undefined;
    return (<Box>
            {
                hasValue ?
                    <Box variant="span">{
                        `${props.value} ${props.unitOfMeasure}`}
                    </Box> : <Box variant="span">-</Box>
            }
        </Box>
    )
}